import { BottomSheet, Text, TextButton, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { Link } from "react-router-dom";

import { useSendAgreementEmail } from "./api/useSendAgreementEmail";

interface EmailAgreementBottomSheetProps {
  modalState: UseModalState;
}

export function EmailAgreementBottomSheet(props: EmailAgreementBottomSheetProps) {
  const { modalState } = props;
  const worker = useDefinedWorker();

  const { mutateAsync: sendEmail, isLoading } = useSendAgreementEmail();

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      footer={
        <DialogFooter orientation="vertical">
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={isLoading}
            onClick={async () => {
              try {
                await sendEmail();
              } catch {}

              modalState.closeModal();
            }}
          >
            Yes, send
          </LoadingButton>
          <TextButton
            LinkComponent={Link}
            size="large"
            sx={{ marginTop: 1, marginBottom: 3 }}
            disabled={isLoading}
            onClick={() => {
              modalState.closeModal();
            }}
          >
            Never Mind
          </TextButton>
        </DialogFooter>
      }
    >
      <DialogContent>
        <Stack spacing={7}>
          <Text variant="h2" textAlign="center">
            Email Your Agreement?
          </Text>
          <Text textAlign="center" sx={{ color: (theme) => theme.palette.text.secondary }}>
            We&apos;ll send an email to {worker.email}
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
